<template>
    <page>
        <module>
            <c-empty v-if="!shelfOptions.length" :message="shelfMessage"></c-empty>
            <view-list
                v-if="shelfOptions.length"
                ref="view"
                work-type="34"
                :view-config="saasInfo.viewmanage"
                selector
            >
                <template #search>
                    <m-search ref="search" :extend-data="searchExtendData">
                        <m-search-item label="货架编码">
                            <c-select name="rackCodePrefix" v-model="rackCodePrefix" :options="shelfOptions" :clear="false" placeholder="请选择货架编码前缀"></c-select>
                        </m-search-item>
                        <m-search-item label="商品编码">
                            <c-input name="productCode" placeholder="请输入商品编码"></c-input>
                        </m-search-item>
                        <m-search-item label="商品IMEI">
                            <c-input name="productImei" placeholder="请输入商品IMEI"></c-input>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_electronic_shelf_light')" prepend-icon="tf-light"
                              @click="batchControlLight()">灯控</c-button>
                    <c-button v-if="auth('b_electronic_shelf_unbind')" prepend-icon="tf-revoke"
                              @click="batchUnbind()">批量解绑</c-button>
                    <!--列表导出（与列表同源调用中台三方分页接口聚合全量）-->
                    <c-button v-if="auth('b_electronic_shelf_export')" prepend-icon="tf-export"
                              @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <template #batchOperate="{data}">
                    <c-button color="main" v-if="auth('b_electronic_shelf_light')" prepend-icon="tf-light"
                              @click="batchControlLight(data)">灯控</c-button>
                    <c-button color="main" v-if="auth('b_electronic_shelf_unbind')" prepend-icon="tf-revoke"
                              @click="batchUnbind(data)">批量解绑</c-button>
                </template>

                <template #create_time="{data}">
                    {{data.create_time || '-'}}
                </template>

                <c-table-column
                    type="button"
                    label="操作"
                    width="120"
                    button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_electronic_shelf_unbind')" icon="tf-unbind" @click="unbindSingle(data)">解绑</c-table-button>
                    </template>
                </c-table-column>
            </view-list>

            <!--灯控指令弹窗-->
            <c-dialog ref="lightDialog" width="600px" mask-close @resolve="submitLight">
                <c-form ref="lightForm" vertical unit-width="100%">
                    <c-form-item label="灯型" required>
                        <c-select v-model="lightType" :options="lightTypeOptions" @change="changeLightType"></c-select>
                    </c-form-item>
                    <c-form-item label="颜色" required>
                        <c-select name="colorCode" v-model="lightColorCode" :options="filteredLightColorOptions"
                                  :disabled="!lightType"></c-select>
                    </c-form-item>
                    <c-form-item label="闪灯等待秒数" required>
                        <c-input name="waitingSeconds" type="number" placeholder="请输入等待秒数"></c-input>
                    </c-form-item>
                </c-form>
                <template #button>
                    <c-button size="dialog" color="main" @click="submitLight">确定</c-button>
                    <c-button size="dialog" @click="$refs.lightDialog.close()">取消</c-button>
                </template>
            </c-dialog>
        </module>
    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'm_electronic_shelf_list',

        computed: {
            ...mapState(['saasInfo']),

            //货架编码未选择时，以全部货架码作为默认筛选条件
            searchExtendData() {
                return {
                    rackCodePrefix: this.rackCodePrefix || this.allRackCodePrefix
                };
            },

            filteredLightColorOptions() {
                let colorCodes = this.lightTypeColorCodeMap[this.lightType] || [];
                return this.lightColorOptions.filter(option => colorCodes.includes(String(option.value)));
            }
        },

        data() {
            return {
                shelfOptions: [],
                rackCodePrefix:'',//已选中的货架编码
                allRackCodePrefix:'',//全部货架码
                shelfMessage: '正在加载商户货架配置',
                lightProductCodes: [],  //灯控指令的商品编码列表
                lightColorOptions: [],
                lightType: '',
                lightColorCode: '',
                lightTypeOptions: [
                    {name: '单色灯', value: 'single'},
                    {name: '闪烁灯', value: 'flash'},
                    {name: '混色灯', value: 'mixed'}
                ],
                lightTypeColorCodeMap: {
                    single: ['OFF', 'WHITE', 'RED', 'GREEN', 'BLUE'],
                    flash: ['RED_FLASH', 'GREEN_FLASH', 'BLUE_FLASH'],
                    mixed: ['RED_GREEN', 'BLUE_RED', 'BLUE_GREEN']
                }
            }
        },
        mounted() {
            this.loadShelfOptions();
            this.loadColorCodeOptions();
        },

        methods: {
            loadShelfOptions() {
                this.request({
                    url: '/electronic/shelf/options',
                    success: data => {
                        this.shelfOptions = (data || []).map(code => ({name: code, value: code}));
                        this.shelfMessage = '当前商户未配置电子货架';
                        this.allRackCodePrefix = this.shelfOptions.map(item => item.value).join(',');
                    },
                    fail: msg => {
                        this.shelfMessage = msg || '加载商户货架配置失败，请刷新重试';
                    }
                });
            },

            changeLightType() {
                this.lightColorCode = '';
            },

            clearLightForm() {
                this.lightType = '';
                this.lightColorCode = '';
                this.$refs.lightForm.clear();
            },

            loadColorCodeOptions() {
                this.request({
                    url: '/dic/info/options',
                    data: {
                        dic_type_code: 'RACK_COLOR_CODE'
                    },
                    success: data => {
                        this.lightColorOptions = data;
                    }
                });
            },
            /*******打开绑定货格弹窗**********/
            openBindDialog() {
                this.$refs.bindForm.clear();
                this.$refs.bindDialog.open({title: '绑定库位'});
            },

            /*******提交绑定货格**********/
            submitBind() {
                this.$refs.bindForm.submit({
                    url: '/electronic/shelf/slots/bind',
                    rule: {
                        slotCode: '请输入库位码',
                        skuCode: '请输入商品SKU编码'
                    },
                    success: (res, msg) => {
                        this.$refs.bindDialog.close();
                        this.$message({message: '绑定库位成功', type: 'success'});
                        this.$refs.view.update();
                    },
                    fail: (msg) => {
                        this.$message({message: msg, type: 'error'});
                    }
                });
            },

            /*******打开灯控指令弹窗（无预选商品）**********/
            openLightDialog() {
                this.lightProductCodes = [];
                this.clearLightForm();
                this.$refs.lightDialog.open({title: '下发灯控指令'});
            },

            /*******批量灯控（基于选中行）**********/
            batchControlLight(batchData) {
                if (!batchData || !batchData.length) {
                    this.$message({message: '请先选择数据', type: 'warning'});
                    return;
                }
                this.lightProductCodes = batchData.map(row => row.skuCode).filter(code => code);
                this.clearLightForm();
                this.$refs.lightDialog.open({title: '下发灯控指令（已选' + this.lightProductCodes.length + '条）'});
            },

            /*******提交灯控指令**********/
            submitLight() {
                this.$refs.lightForm.submit({
                    url: '/electronic/shelf/lights/by-products',
                    rule: {
                        colorCode: '请选择灯色'
                    },
                    dataFormatter: data => {
                        data.productCodes = this.lightProductCodes;
                        if (data.waitingSeconds) {
                            data.waitingSeconds = parseInt(data.waitingSeconds);
                        } else {
                            delete data.waitingSeconds;
                        }
                        return data;
                    },
                    success: (res, msg) => {
                        this.$refs.lightDialog.close();
                        this.$message({message: '灯控指令已受理', type: 'success'});
                    },
                    fail: (msg) => {
                        this.$message({message: msg, type: 'error'});
                    }
                });
            },

            /*******单行解绑**********/
            unbindSingle(data) {
                if (!data.skuCode) {
                    this.$message({message: '该记录无商品编码，无法解绑', type: 'warning'});
                    return;
                }
                this.$confirm({
                    message: '确认解绑商品编码【' + data.skuCode + '】？',
                    buttonName: '确定解绑',
                    cancelButton: true,
                    resolve: () => {
                        this.request({
                            url: '/electronic/shelf/bindings/unbind',
                            data: {productCodes: [data.skuCode]},
                            loading: true,
                            success: (res, msg) => {
                                this.$message({message: '解绑成功', type: 'success'});
                                this.$refs.view.update();
                            }
                        });
                    }
                });
            },

            /*******批量解绑**********/
            batchUnbind(batchData) {
                if (!batchData || !batchData.length) {
                    this.$message({message: '请先选择数据', type: 'warning'});
                    return;
                }
                let productCodes = batchData.map(row => row.skuCode).filter(code => code);
                if (!productCodes.length) {
                    this.$message({message: '选中记录中无有效的商品编码', type: 'warning'});
                    return;
                }
                this.$confirm({
                    message: '确认批量解绑 ' + productCodes.length + ' 条商品绑定记录？',
                    buttonName: '确定解绑',
                    cancelButton: true,
                    resolve: () => {
                        this.request({
                            url: '/electronic/shelf/bindings/unbind',
                            data: {productCodes: productCodes},
                            loading: true,
                            success: (res, msg) => {
                                this.$message({message: msg || '批量解绑成功', type: 'success'});
                                this.$refs.view.update();
                            }
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped lang="stylus">
    .m-inline-form-item {
        display: flex;
        align-items: center;

        /deep/ .u-form-label,
        /deep/ .c-form-item__label,
        /deep/ label {
            width: auto !important;
            margin-right: 12px;
            margin-bottom: 0 !important;
            flex-shrink: 0;
        }

        /deep/ .u-form-content,
        /deep/ .c-form-item__content {
            flex: 1;
        }
    }
</style>

<style lang="stylus">
    .m-inline-form-item .c-radio-group {
        display: inline-flex !important;
        flex-wrap: wrap;
        gap: 16px;
        vertical-align: middle;
    }

    .m-inline-form-item .c-radio-group .c-radio {
        display: inline-flex !important;
        align-items: center;
        margin: 0 !important;
        white-space: nowrap;
    }
</style>
